function degreesToRadians(degrees: number) {
  return degrees * (Math.PI / 180);
}

export function haversineDistance(lat1: any, lon1: any, lat2: any, lon2: any) {
  const R = 3440.07; // Earth's radius in nautical miles

  const lat1Rad = degreesToRadians(lat1);
  const lon1Rad = degreesToRadians(lon1);
  const lat2Rad = degreesToRadians(lat2);
  const lon2Rad = degreesToRadians(lon2);

  const dLat = lat2Rad - lat1Rad;
  const dLon = lon2Rad - lon1Rad;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.asin(Math.sqrt(a));

  const distance = R * c;
  return distance;
}
